import { Component, NgZone, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, selectProfile } from '@app/core/ngrx';
import { MSALAuthService } from '@app/auth/msal-auth.service';

/**
 * LoginStaticFormComponent
 */
@Component({
  selector: 'ecp-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  /**
   * loginForm
   */
  loginForm: FormGroup;
  /**
   * error$
   */
  // @select(['auth', 'error'])
  error$: Observable<any>;
  /**
   * pending$
   */
  // @select(['auth', 'pending'])
  pending$: Observable<boolean>;
  /**
   * profile$
   */
  // @select(['user', 'profile'])
  profile$: Observable<any>;
  /**
   * rememberMeFlag
   */
  rememberMeFlag;

  /**
   * constructor
   * @param {NgRedux<AppState>} redux
   * @param {AuthService} authService
   * @param {Router} router
   * @param {AuthStaticService} loginService
   */
  constructor(
    private _ngZone: NgZone,
    private store: Store<AppState>,
    private authService: MSALAuthService,
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.error$ = this.store.pipe(select(state => state.auth.error));
    this.pending$ = this.store.pipe(select(state => state.auth.pending));
    this.profile$ = this.store.pipe(select(selectProfile));
  }
  onLogin(): void {
    this.authService.login();
  }
}
